import(/* webpackMode: "eager", webpackExports: ["SWRConfig"] */ "/opt/build/repo/app/_providers/SWRConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer"] */ "/opt/build/repo/components/layout/Layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/Price/MobileFooter/MobileFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayoutIsland"] */ "/opt/build/repo/components/pages/Price/PageLayoutIsland.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PriceHeading"] */ "/opt/build/repo/components/pages/Price/PricePageLayout/PriceHeading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricePageContent"] */ "/opt/build/repo/components/pages/Price/PricePageLayout/PricePageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricePageSidePanel"] */ "/opt/build/repo/components/pages/Price/PricePageLayout/PricePageSidePanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagProvider"] */ "/opt/build/repo/hooks/useFeatureFlags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/opt/build/repo/node_modules/swr/dist/index/config-client-Bi4rgVRk.mjs");
